import storejs from 'storejs'

export const getDirection  = state => {
    return state.UPDATE_DIRECTION;
}
//获得TOKEN
export const getToken = state => {
    return state.USER_OPTIONS.TOKEN;
}
//获得上个进入的页面
export const getRouter = state => {
	return state.ROUTER_HISTORY;
}
//获得父级别的ID 
export const getPId = state => {
    return state.CHOSE_PARTS.CHOSEPID;
}

//所有的参数
export const getServicesParams = state =>{
	return state.CHOSE_PARTS.SERVICESPARAMS;
};
//所有的配件
export const getGroupServices=state => {
	return state.CHOSE_PARTS.GROUPSERVICES;
}
//获得配件
export const getParts = state => {
    return  storejs.get('parts');
}
//获得选择的服务
export const getServices = state =>{
	return state.CHOSE_PARTS.CHOSESERVICES
}
//获得被更换的配件
export const getChoseParts = state => {
	return state.CHOSE_PARTS.CHOSEPARTS
}

//获得需要更换的配件
export const getReplaceParts = state => {
	return state.CHOSE_PARTS.REPLACEPARTS
}

//获取订单信息
export const getOrderInfo = state => {
	return state.ORDER_INFO;
    //return storejs.get('orderInfo');
}
//获得车的品牌
export const getCarBrand = state => {
	return state.CHOSE_CAR.CAR_BRAND;
	//return storejs.get("carBrand");
}

//获得车型
export const getCarModel = state => {
	return state.CHOSE_CAR.CAR_MODEL;
	//return storejs.get("carModel");
}

//获得排量
export const  getCarDisplacement = state => {
	return state.CHOSE_CAR.CAR_DISPLACEMENT;
    //return storejs.get("eniends");
}

//获取年月
export const  getCarProYear = state => {
	return state.CHOSE_CAR.CAR_YEAR;	
    //return storejs.get("proyear");
}

//获得车的基本信息
export  const  getCarBaseInfo = state => {
	return state.CHOSE_CAR.CAR_INFO;		
    //return storejs.get("baseInfo");
}

//获得城市的信息
export const getCityInfo = state => {
	return storejs.get('cityOption');
}

//获得地址

export const getAddressInfo = state => {
	return state.ADDRESS_OPTION.ADDRESS;
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js